export default {
  ACCOUNT: '/compte',
  INFO: '/informations',
  ORDERS: '/commandes',
  ORDERS_OFFLINE: '/commandes-hors-ligne',
  ADDRESSES: '/adresses',
  TRACKING: '/suivi-commande',
  RETURNS: '/retours',
  ONLINE_RETURNS: '/retours/en-ligne',
};
